// extracted by mini-css-extract-plugin
export default {"root":"wRmB0N749kG9osJRbVCX","label":"_5pe7VxKnFRi6i0j1NhD","duration":"MvtmMs19apA58BhjSLq9"};